import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearToken } from "@/lib/api";
import { LogOut, Plus } from "lucide-react";

export default function AdminLayout() {
  const navigate = useNavigate();
  const onLogout = () => {
    clearToken();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-zinc-50">
      <header
        className="sticky top-0 z-30 backdrop-blur-xl bg-white/70 border-b border-zinc-200"
        data-testid="admin-header"
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            data-testid="brand-home-link"
            className="font-display text-xl tracking-tight text-zinc-900"
          >
            Invoice<span className="text-zinc-400">.</span>App
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm">
            <NavLink
              to="/"
              end
              data-testid="nav-dashboard"
              className={({ isActive }) =>
                `transition-colors ${
                  isActive ? "text-zinc-900" : "text-zinc-500 hover:text-zinc-900"
                }`
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/new"
              data-testid="nav-new-invoice"
              className={({ isActive }) =>
                `transition-colors ${
                  isActive ? "text-zinc-900" : "text-zinc-500 hover:text-zinc-900"
                }`
              }
            >
              New Invoice
            </NavLink>
          </nav>
          <div className="flex items-center gap-3">
            <Link
              to="/new"
              data-testid="header-new-invoice-button"
              className="hidden sm:inline-flex items-center gap-2 bg-zinc-900 text-white rounded-none px-5 py-2.5 text-sm font-medium hover:bg-zinc-800 transition-colors"
            >
              <Plus size={16} /> New Invoice
            </Link>
            <button
              onClick={onLogout}
              data-testid="logout-button"
              className="inline-flex items-center gap-2 border border-zinc-200 rounded-none px-4 py-2.5 text-sm font-medium text-zinc-700 hover:border-zinc-900 transition-colors"
            >
              <LogOut size={14} /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
